import { useCallback, useEffect, useRef, useState } from "react";
import { PackEditorCallbacks } from "../core/EditorTypes";
import { Pack } from "../Types";
import { EditableText } from "./EditableText";

type Props = {
  tags: Pack["metadata"]["tags"];
  packEditorCallbacks: PackEditorCallbacks;
};

export const TagsEditor = (props: Props) => {
  const { tags, packEditorCallbacks } = props;
  const { modifyPackTags } = packEditorCallbacks;

  const editPackTag = useCallback((index: number) => (text: string) => {
    const newTags = [...tags];
    newTags[index] = text;
    modifyPackTags(newTags);
  }, [tags, modifyPackTags]);

  const eraseTag = useCallback((index: number) => () => {
    let newTags = [...tags];
    // just remove the one
    newTags.splice(index, 1);
    modifyPackTags(newTags);
  }, [tags, modifyPackTags]);

  const addTag = useCallback(() => {
    const newTags = [...tags, "#blank"];
    modifyPackTags(newTags);
  }, [tags, modifyPackTags]);

  return (
    <div className="tags-container">
      {tags.map((tag, index) => (
        <Tag
          key={index}
          name={tag}
          write={editPackTag(index)}
          erase={eraseTag(index)}
        />
      ))}
      <button className="add tag" onClick={addTag}>+ add tag</button>
    </div>
  );
};

type TagProps = {
  name: string;
  write: (string) => void;
  erase: () => void;
};

export const Tag = (props: TagProps) => {
  const { name, write, erase } = props;
  const [editing, setEditing] = useState(false);

  const inputRef = useRef<HTMLInputElement>(null);

  useEffect(() => {
    if (editing && inputRef.current) {
      inputRef.current.focus();
    }
  }, [editing, inputRef]);

  if (editing) {
    return (
      <span
        className="tag-container"
      >
        <span className="icon" style={{ zIndex: 999 }}>
          <img
            src={`/icons/trash.png`}
            alt={`trash icon`}
            onMouseDown={(e) => {
              // e.preventDefault();
              // e.stopPropagation();
              erase();
            }}
          />
        </span>
        <input
          ref={inputRef}
          type="text"
          value={name}
          className="tag editing"
          onChange={(e) => write(e.target.value)}
          onBlur={() => setEditing(false)}
          onBlurCapture={() => setEditing(false)}
        >
        </input>
      </span>
    );
  }

  return (
    <span
      className="tag"
      onClick={() => setEditing(true)}
      onBlur={() => setEditing(false)}
      onBlurCapture={() => setEditing(false)}
    >
      {name}
    </span>
  );
};
